import { useQuery } from '@tanstack/react-query';
import { ErrorHandler } from '@helper/errorHandler';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { APICONFIG } from '@config/api.config';
import { FccSlabPayload } from '.';

export const useFccSlabQuery = (): IQueryResponse<FccSlabPayload> => {
	const fetchFccSlabData = async (): Promise<FccSlabPayload> => {
		try {
			return await APIService.getData<FccSlabPayload>(APICONFIG.FCC_USER_SLAB);
		} catch (error) {
			ErrorHandler(error);
			throw error;
		}
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['fccSlab'],
		queryFn: fetchFccSlabData,
		refetchOnWindowFocus: false,
		enabled: true,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
